import React from "react";
import { Link, LinkContainer, LinkHeading, LinksAnchor } from "./FooterLink.styles";

const FooterLink = ({ heading, links, className }) => {
  return (
    <LinkContainer className={className}>
      <LinkHeading>{heading}</LinkHeading>

      <LinksAnchor>
        {links.map((link, idx) => (
          <Link href="/" key={idx}>
            {link}
          </Link>
        ))}
      </LinksAnchor>
    </LinkContainer>
  );
};

export default FooterLink;
